import { CoreIcon } from '../core-icon';
import infoCircleSVG from '../../assets/icons/info-circle.svg';
import type { IconProps } from '../core-icon';

export const InfoCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={infoCircleSVG} {...props} />;
};
